import * as React from 'react';

import { BrowserRouter, Switch, Route, useLocation } from 'react-router-dom';

import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import {
    CssBaseline,
    Container,
    Typography,
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button
} from '@material-ui/core';

// import type { LabComponentNameToClassKey, LabComponentsPropsList } from '@material-ui/lab/themeAugmentation';

import { SnackbarProvider } from 'notistack';

import { TitleBar } from './titlebar';
import * as Pages from './pages';

import {
    ServiceClientProvider,
    Preferences, PreferencesProvider, usePreferences,
    Settings, SettingsProvider, useSettings
} from './contexts';

const theme = createMuiTheme({
    // spacing: 25
    palette: {
        // primary: {
        //     main: '#1e88e5',
        //     light: '#6ab7ff',
        //     dark: '#005cb2'
        // },
        // secondary: {
        //     main: '#512da8',
        //     light: '#8559da',
        //     dark: '#140078'
        // },
        background: {
            default: '#F0F4F9',
        },
    },
    // overrides: {
    //     MuiTimeline: {
    //         root: {
    //             backgroundColor: 'red'
    //         }
    //     }
    // }
});

interface Page {
    path: string;
    exact?: boolean;
    title?: string;
    element: JSX.Element;
}
const pages: ReadonlyArray<Page> = [
    {
        path: '/',
        exact: true,
        element: <Pages.Home />
    },
    {
        path: '/data-access/:artifact?',
        element: <Pages.DataAccess />
    },
    {
        path: '/configuration',
        element: <Pages.Configuration />
    },
    {
        path: '/louver-selection/:tab?',
        element: <Pages.LouverSelection />
    },
    {
        path: '/louver',
        element: <Pages.Louver />
    },
    {
        path: '/louver-xm',
        element: <Pages.LouverXM />
    },
    {
        path: '/batch-testing',
        element: <Pages.BatchTesting />
    },
    {
        path: '/grd',
        element: <Pages.Grd />
    }
]

export function Router() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />

            <SnackbarProvider maxSnack={15} dense>
                <BrowserRouter>
                    <SettingsProvider>
                        <PreferencesProvider>
                            <AppWrapper />
                        </PreferencesProvider>
                    </SettingsProvider>
                </BrowserRouter>
            </SnackbarProvider>
        </ThemeProvider>
    )
}

function AppWrapper() {
    const [ settings ] = useSettings();

    return (
        <ServiceClientProvider url={settings.servicesUrl}>
            <App />
        </ServiceClientProvider>
    )
}
function App() {
    const [ showSettings, setShowSettings ] = React.useState<boolean>();
    const location = useLocation();

    return (
        <React.Fragment>
            <Switch>
                {pages.map(page => (
                    <Route path={page.path} exact={page.exact}>
                        <TitleBar title={page.title} onSettingsClick={() => setShowSettings(true)} />
                        <Container maxWidth="xl">
                            {page.element}
                        </Container>
                    </Route>
                ))}

                <Route path="*">
                    <TitleBar title="Gnosis Tester" onSettingsClick={() => setShowSettings(true)} />
                    <Container maxWidth="xl">
                        <Typography variant="h2">Page not found <code>{location.pathname}</code></Typography>
                    </Container>
                </Route>
            </Switch>

            <SettingsDialog show={showSettings} onClose={() => setShowSettings(false)} />
        </React.Fragment>
    )
}

interface SettingsDialogProps {
    show?: boolean;
    // onSave?: (settings: Settings) => void;
    onClose?: () => void;
}
function SettingsDialog({ show, onClose }: SettingsDialogProps) {
    const [ settings, setSettings ] = useSettings();

    const [ values, setValues ] = React.useState<Partial<Settings>>({});
    React.useEffect(() => {
        setValues({ ...settings });
    }, [ settings ]);

    const onSaveHandler = () => {
        setSettings(prev => ({
            ...prev,
            ...values
        }));

        onClose?.();
    }

    return (
        <Dialog open={!!show} onClose={onClose}>
            <DialogTitle id="form-dialog-title">Settings</DialogTitle>
            <DialogContent>
                <TextField id="servicesUrl" margin="dense" autoFocus label="Services URL" fullWidth value={values.servicesUrl ?? ''} onChange={(e) => setValues(prev => ({ ...prev, servicesUrl: e.target.value }))} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onSaveHandler}>Save</Button>
                <Button onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}